import { createSlice } from "@reduxjs/toolkit";

const initialState = {};
const CommentsReducer = createSlice({
  name: "Comments",
  initialState,
  reducers: {
    defaultAction: (state, { payload }) => {
      console.log("CommentsReducer state and payload", state, payload);
    },
  },
});

const { reducer, actions } = CommentsReducer;
export const { defaultAction } = actions;
export default reducer;
